export const normalizeSelectInputValue = (value, isMulti = true) => {
  if (isMulti) {
    return value;
  }

  return value.slice(-1);
};
